import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const AddIcon = ({ type = 'large', color = 'black', customSize, thickness = 1 }) => {
  const defaultSize = (type === 'large') ? 11 : 8;
  const size = customSize ? customSize : defaultSize;
  const halfSize = size / 2 + thickness / 4 + 0.25;

  return (
    <svg style={style} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y={halfSize} width={thickness} height={size} transform={`rotate(-90 0 ${halfSize})`} fill={color} />
      <rect x={halfSize} y={size} width={thickness} height={size} transform={`rotate(180 ${halfSize} ${size})`} fill={color} />
    </svg>
  );
};

export default AddIcon;
